<div class="info-container">
  <div class="info-sub-container">
    <div class="info-sub-container2">
      <div class="title-container">
        <div class="title">Family Information</div>
      </div>
      <div class="content-container">
        <div class="left-panel">
          <div class="panel-l1">
            <div class="panel-l2"></div>
            <div class="panel-l3"></div>
            <div class="panel-l4"></div>
          </div>
          <div class="left-container">
            <div class="label-item">{{ title }}</div>
            @if (propertiesListItems.length > 0) {
              <div class="properties-container">
                <sysque-properties-list
                  class="properties-list-container"
                  [propertiesListItems]="propertiesListItems"
                  (valueChanged)="onPropertiesValueChanged($event)"
                >
                </sysque-properties-list>
              </div>
            }
            <div class="additional-wire-length-container">
              @if (isadditionalWireLengthVisible && additionalWireLengthItems.length > 0) {
                <div>
                  <sysque-number-box-options-line
                    [numberBoxItems]="additionalWireLengthItems"
                    [showSpinButtons]="additionalWireLengthSpinButtons"
                    (valueChanged)="
                      onAdditionalWireLengthValueChanged({ value: $event.value.toString(), label: $event.label })
                    "
                  >
                  </sysque-number-box-options-line>
                </div>
              }
            </div>
            <div class="pdf-location-project-data-container">
              <div class="pdf-location-container">
                <sysque-pdf-location
                  [fileName]="fileName"
                  (attachFileClicked)="onAttachFileClicked()"
                  (openPdf)="onOpenPdf()"
                >
                </sysque-pdf-location>
              </div>
            </div>
          </div>
        </div>
        <div class="right-panel">
          <div class="panel-l1">
            <div class="panel-l2"></div>
            <div class="panel-l3"></div>
            <div class="panel-l4"></div>
          </div>
          <div class="right-container">
            @if (connectorsItems.length > 0) {
              <div class="connectors-container">
                <sysque-dropdown-connectors
                  [title]="connectorsTitle"
                  [connectors]="connectorsItems"
                  (valueChanged)="onConnectorValueChanged($event)"
                >
                </sysque-dropdown-connectors>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sysque-alert">
    @if (isAlertVisible) {
      <alert [alert]="alert" (alertClosed)="hideAlert()"></alert>
    }
  </div>
  <div class="action-container">
    <dx-button id="apply-button" class="done" (onClick)="doneClick()" text="Done"> </dx-button>
  </div>
</div>
